import { SettingsPageContent } from "../../settings/settings"

const AccountTab = () => {
  return (
    <div className="flex flex-col gap-6 pt-4">
      <SettingsPageContent />
    </div>
  )
}

export default AccountTab
